
import axios from "axios";

const firebaseDatabaseURL = process.env.VUE_APP_FIREBASE_DATABASE_URL;

if (!firebaseDatabaseURL) {
  throw new Error("Missing Firebase database environment variable");
}

const journalApi = axios.create({
    baseURL: firebaseDatabaseURL
})


journalApi.interceptors.request.use((config)=>{
    config.params = {
        auth: localStorage.getItem('idToken')
    }

    return config
})


export default journalApi
